import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';

import { AdminModule } from './admin/admin.module';
import { FrontModule } from './front/front.module';
import { SharedModule } from './shared/shared.module';

//     
@NgModule({
  declarations: [ 
    AppComponent
  ],
  imports: [ 
    SharedModule.forRoot(), 
    AdminModule, 
    FrontModule,
  ],
  providers: [ 
  ], 
})
export class AppModule {
}

export { AppComponent } from './app.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.module.ts